import React, { ComponentProps, useMemo } from 'react';
import { Input } from 'reactstrap';
import Cleave from 'cleave.js/react';
import { CleaveOptions } from 'cleave.js/options';

interface Props
  extends Omit<CleaveOptions, 'onChange' | 'value'>,
    Omit<ComponentProps<typeof Input>, 'onChange' | 'value'> {
  value?: number | null;
  onChange: (value: number) => void;
}

const NumberInput: React.FC<Props> = ({ value, onChange, ...other }) => {
  const options: CleaveOptions = useMemo(() => {
    return {
      numeral: true,
      numeralDecimalScale: 0,
      numeralPositiveOnly: true,
      numeralThousandsGroupStyle: 'none',
    };
  }, []);

  return (
    <Cleave
      options={options}
      value={value || ''}
      className="form-control"
      onChange={(event) => {
        onChange(parseInt(event.target.rawValue) || 0);
      }}
      type="number"
      inputMode="numeric"
      {...other}
    />
  );
};

export default NumberInput;
